import './mini.css';
import logo from './icons/logo.png';
import Home from './icons/Home.png';
import settingsss from './icons/settingsss.png'
import logout from './icons/logout.png';
import Sbutton from './icons/whiteSButton.png';
import Hbutton from './icons/blueHButton.png';
import { useState } from 'react';
import logoutb from './icons/logoutb.png'   //called
import { useNavigate,useLocation } from "react-router-dom";
import Work from './icons/Work.png';
import ConfirmationModal from "./ConfirmationModal";




function Header(props) {
  const [isSettingsHovered, setIsSettingsHovered] = useState(false);
  const [isHomeHovered, setIsHomeHovered] = useState(false);
  const [isLogoutHovered, setIsLogoutHovered] = useState(false);
  const [isEmployeesHovered, setIsEmployeesHovered] = useState(false);
  const [isLogoutPopupOpen, setIsLogoutPopupOpen] = useState(false);

  const navigate = useNavigate();

  const location = useLocation();

  // Retrieve the username from the location state
  const username = location.state?.username || '';

  const handleSettingsMouseEnter = () => {
    setIsSettingsHovered(true);
  };

  const handleSettingsMouseLeave = () => {
    setIsSettingsHovered(false);
  };

  const handleHomeMouseEnter = () => {
    setIsHomeHovered(true);
  };

  const handleHomeMouseLeave = () => {
    setIsHomeHovered(false);
  };

  const handleLogoutMouseEnter = () => {      //called
    setIsLogoutHovered(true);
  };

  const handleLogoutMouseLeave = () => {        //called
    setIsLogoutHovered(false);
  };

  const handleEmployeesMouseEnter = () => {
    setIsEmployeesHovered(true);
  };

  const handleEmployeesMouseLeave = () => {
    setIsEmployeesHovered(false);
  };

  const backLogin = () => {
    setIsLogoutPopupOpen(true);
  };
  const confirmLogout = () => {
    setIsLogoutPopupOpen(false);
    navigate("/");
  };

  const cancelLogout = () => {
    setIsLogoutPopupOpen(false);
  };

  return (
    <>
      <ConfirmationModal
        isOpen={isLogoutPopupOpen}
        onConfirm={confirmLogout}
        onCancel={cancelLogout}
        message="Are you sure you want to logout?"
      />
      <div className="sidebar"  >

        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="buttons sidebar-buttons">

          <div >
            <button type="button" className="hovered-button"
              onMouseEnter={handleHomeMouseEnter}
              onMouseLeave={handleHomeMouseLeave}
              onClick={() => navigate("/home", { state: { username } })} // Navigate to the "/home" route
            >

              <img src={isHomeHovered ? Hbutton : Home} alt="Home" />
            </button>
            <div className={`hometext ${isHomeHovered ? 'hovered' : ''}`}>
              <span className="name" >Home</span>
            </div>
          </div>

          <div className="set">
            <button type="button" className="setb"
              onMouseEnter={handleEmployeesMouseEnter}
              onMouseLeave={handleEmployeesMouseLeave}
              onClick={() => navigate("/manage-employees", { state: { username } })} // Navigate to the "/manage-employees" route
            >
              <img src={Work} alt="Manage Employees" style={{ filter: isEmployeesHovered ? 'invert(48%) sepia(79%) saturate(1000%) hue-rotate(182deg) brightness(98%) contrast(101%)' : 'none' }} />
            </button>
            <div className={`settings ${isEmployeesHovered ? 'hovered' : ''}`}>
              Employees
            </div>
          </div>

          <div className="set">

            <button type="button" className="setb"
              onMouseEnter={handleSettingsMouseEnter}
              onMouseLeave={handleSettingsMouseLeave}
              onClick={() => navigate("/settings", { state: { username } })} // Navigate to the "/settings" route
            >
              <img src={isSettingsHovered ? settingsss : Sbutton} alt="settings" />
            </button>
            <div className={`settings ${isSettingsHovered ? 'hovered' : ''}`}>
              Settings
            </div>
          </div>
        </div>

        <div className="lb">
          <hr />
          <button type="button" className="logb"
            onMouseEnter={handleLogoutMouseEnter}  //called
            onMouseLeave={handleLogoutMouseLeave}  //called
            onClick={backLogin}
          >
            <img src={isLogoutHovered ? logoutb : logout} alt="logout" />
          </button>
          <button type='button' className={`logout-btn ${isLogoutHovered ? 'hovered' : ''}`} onClick={() => setIsLogoutPopupOpen(true)}>
            Logout
          </button>
        </div>



      </div>
    </>

  );
}

export default Header;
